import { IsNumber, IsString } from 'class-validator';

export class AssetDto {
  @IsNumber()
  asset_id: number;
  
  @IsString()
  public_asset_url: string;

  @IsNumber()
  file_size: number;

  @IsString()
  file_type: string;
}
